/* eslint-disable @typescript-eslint/no-empty-function */
import React from 'react';

import { DropdownFilter, Input, Title } from '@fnacdarty/back-office-ui';
import PropTypes from 'prop-types';

import {
	StyledFilterContainer,
	StyledInputSearchContainer,
	StyledDropdownContainer,
	StyledHeader,
	StyledSearchIcon,
} from './index.styled';

const ActivityFilter = ({
	filters,
	updateSearch,
	updateResources,
	updateTreatments,
}) => {
	const sortedRessources = filters.resources.sort((a, b) => {
		if (a.name < b.name) {
			return -1;
		}
		if (a.name > b.name) {
			return 1;
		}
		return 0;
	});

	return (
		<StyledFilterContainer>
			<StyledInputSearchContainer>
				<Input
					placeholder="Rechercher..."
					type="text"
					value={filters.search}
					onChange={updateSearch}
				/>
				<StyledSearchIcon name="search" width="20px" />
			</StyledInputSearchContainer>
			<StyledHeader style={{ marginTop: '20px' }}>
				<Title level={3}>Filtrer par</Title>
				<hr />
			</StyledHeader>
			<StyledDropdownContainer>
				<DropdownFilter
					title="Ressources"
					identifier="name"
					label="name"
					options={sortedRessources}
					setOptions={updateResources}
					multiSelect={true}
				/>
			</StyledDropdownContainer>
			<StyledDropdownContainer>
				<DropdownFilter
					title="Traitements"
					options={filters.treatments}
					setOptions={updateTreatments}
					multiSelect={true}
				/>
			</StyledDropdownContainer>
		</StyledFilterContainer>
	);
};

export default ActivityFilter;

ActivityFilter.propTypes = {
	filters: PropTypes.object.isRequired,
	updateSearch: PropTypes.func.isRequired,
	updateResources: PropTypes.func.isRequired,
	updateTreatments: PropTypes.func.isRequired,
};
